import { doc, getDoc, collection, query, where, getDocs } from 'firebase/firestore'
import firebase from '../../firebase'

const getDevices = () => {
  const getDeviceById = async (id) => {
    try {
      const deviceRef = doc(firebase.db, 'devices', id)
      const deviceSnapShot = await getDoc(deviceRef)

      if (deviceSnapShot.exists()) {
        return deviceSnapShot.data()
      } else {
        console.log('No such document!')
      }
    } catch (error) {
      console.log(error)
    }
  }

  const getOwnedDevicesByUserId = async (id) => {
    const devices = []
    const deviceRef = collection(firebase.db, 'devices')
    const q = query(deviceRef)
    const querySnapshot = await getDocs(q)

    querySnapshot.forEach((doc) => {
      const deviceType = doc.data().deviceType === 'Knee Brace 2' ? 'Knee Brace' : doc.data().deviceType
      devices.push({
        deviceType: deviceType,
        id: doc.id
      })
    })

    const userRef = doc(firebase.db, 'users', id)
    const userSnapShot = await getDoc(userRef)

    const results = []
    devices.forEach((device) => {
      if (userSnapShot.data().devices[device.id]) {
        results.push({ ...device, side: userSnapShot.data().devices[device.id] })
        device.side = userSnapShot.data().devices[device.id]
      } else {
        device.side = 'Left'
      }
    })
    return results
  }
  return { getDeviceById, getOwnedDevicesByUserId }
}
export default getDevices
